module.exports = __webpack_public_path__ + "img/07_ic_leveler_black_62px.447068e7.svg";